import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IAccount } from "../models/account/IAccount";
import { DefaultResponseWithData } from "../models/system";
import apiConfig from "../utils/apiConfig";

// Accounts flagged as hauliers (third-party waste carriers), for the Waste Tracking dropdown
// and the Hauliers page. Keyed under "accounts" so every account mutation already invalidates it.
export default function useHaulierAccounts(componentName = "useHaulierAccounts") {
  const { get } = useApiHelper(apiConfig(componentName));

  const haulierAccounts = useQuery({
    queryKey: ["accounts", "hauliers"],
    queryFn: () => get<DefaultResponseWithData<IAccount[]>>(`/account/hauliers`),
    staleTime: 1000 * 60,
  });

  return {
    haulierAccounts,
  };
}
